import { SkeletonLoader } from "@whoosh/design-system/src/components/display";
import {
  Box,
  HStack,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

export const ClubSelectionResultsSkeleton = () => {
  return (
    <VStack gap={2}>
      <SkeletonCard opacity={1} />
      <SkeletonCard opacity={0.5} />
    </VStack>
  );
};

const SkeletonCard = ({ opacity }: { opacity: number }) => {
  return (
    <Box
      width="100%"
      borderRadius="2"
      borderWidth={2}
      borderColor="surface-dividers"
      opacity={opacity}
    >
      <HStack justifyContent="space-between" alignItems="center" padding={4}>
        <VStack gap={2}>
          <SkeletonLoader height={12} width={156} />
          <SkeletonLoader height={8} width={94} />
        </VStack>
        <SkeletonLoader height={56} width={56} borderRadius="2" />
      </HStack>
    </Box>
  );
};
